import styled, { css } from 'styled-components'
import { Spacing, Colors } from 'cio-design-library/design-tokens'
import { ScrollContainer } from 'builder/components/ScrollContainer'

export const ReviewSection = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${Spacing.XS};
  background-color: ${Colors.White};
  padding: 20px ${Spacing.M} ${Spacing.M};
  gap: ${Spacing.S};
`

export const ReviewFullSection = styled(ReviewSection)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0;
`

export const ReviewFullSectionWrapper = styled(ScrollContainer)(() => {
  const offsetTop = `56px`
  return css`
    display: flex;
    flex-direction: column;
    margin-top: ${offsetTop};
    width: 100%;
    height: calc(100% - ${offsetTop});
    padding: 12px 20px 20px;
  `
})
